/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { MdOutlinePeopleOutline } from 'react-icons/md';

import Modal from 'react-bootstrap/Modal';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
// import AppModal from "../../../shared/components/app-modal/AppModal";
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { getAllStaff, updatePasswordForStaff } from '../../../api/profileApi';
import Staff from './Staff';
import AddOrEditStaff from './AddOrEditStaff';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import './StaffPage.scss';
import AccountsPageHorizontalBar from '../accounts/AccountsPageHorizontalBar';

function StaffPage() {
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [alert, setAlert] = useState(undefined);
  const apiProcessingRef = useRef(false);
  const selectedStaffRef = useRef(undefined);
  const staffForPasswordChangeRef = useRef(undefined);
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [validationError, setValidationError] = useState(false);

  const handleOpenEdit = (selectedStaff) => {
    selectedStaffRef.current = {
      profileid: selectedStaff.ProfileId,
      agentid: selectedStaff.AgentId,
      userid: selectedStaff.UserId,
      salutation: selectedStaff.Salutation,
      first_name: selectedStaff.FirstName,
      last_name: selectedStaff.LastName,
      contact_email: selectedStaff.ContactEmail,
      mobile_number: selectedStaff.MobileNumber,
      contact_number: selectedStaff.ContactNumber,
      address1: selectedStaff.Address1,
      address2: selectedStaff.Address2,
      city: selectedStaff.City,
      state: selectedStaff.State,
      country: selectedStaff.Country,
      pincode: selectedStaff.PinCode,
      status: selectedStaff.Status,
    };
    setOpenAddDialog(true);
  };

  const getStaffList = async () => {
    setIsLoading(true);
    const response = await getAllStaff();
    if (response && response.Root && response.Root.Status === 'OK') {
      const { Result } = response.Root;
      const users = Array.isArray(Result.User) ? Result.User : [Result.User];
      setStaffList(users);
    } else {
      setAlert({
        title: 'Staff',
        description: response.Root.Message,
        variant: 'error',
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (!apiProcessingRef.current) {
      apiProcessingRef.current = true;
      getStaffList();
    }
  }, []);

  const handleOpenPasswordChangeModal = (staff) => {
    staffForPasswordChangeRef.current = staff.AgentId;
    setShowChangePasswordPopup(true);
  };

  const onClosePasswordModal = () => {
    setShowChangePasswordPopup(false);
    staffForPasswordChangeRef.current = undefined;
    setNewPassword('');
    setConfirmNewPassword('');
  };

  const handleSuccess = (response) => {
    if (response && response.ApiStatus.Status === 'OK') {
      setAlert({
        title: 'Staff',
        description: response.ApiStatus.Message,
        variant: 'success',
      });
      setOpenAddDialog(false);
      apiProcessingRef.current = false;
      getStaffList();
    } else {
      setAlert({
        title: 'Staff',
        description: response.ApiStatus.Message,
        variant: 'error',
      });
    }
  };

  const handleChangePasswordForStaff = async () => {
    if (
      newPassword === '' ||
      confirmNewPassword === '' ||
      newPassword === '\n' ||
      confirmNewPassword === '\n'
    ) {
      setValidationError(true);
      return false;
    }
    if (newPassword !== confirmNewPassword) {
      setAlert({
        variant: 'error',
        title: 'Change Password',
        description: 'New password and Confirm password should match',
      });
      return false;
    }
    setIsLoading(true);
    const res = await updatePasswordForStaff(
      newPassword,
      staffForPasswordChangeRef.current,
    );
    if (res && res.ApiStatus?.Status === 'OK') {
      onClosePasswordModal();
      setAlert({
        variant: 'Success',
        title: 'Change Password',
        description: res.ApiStatus?.Message,
      });
    } else {
      onClosePasswordModal();
      setAlert({
        variant: 'error',
        title: 'Change Password',
        description: res ? res.ApiStatus?.Message : 'Failed to change password',
      });
    }
    setIsLoading(false);
  };

  return (
    <div className="staf-page py-4">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
          variant={alert.variant}
        />
      )}
      <AccountsPageHorizontalBar selectedPage="add-view-staff" />
      <div className="staff-page_container">
        <div className="staff-page_heading d-flex justify-content-between align-items-center">
          <span className="staff-page_header">Staff</span>
          <AppButton
            btnText="Add staff"
            className="fs-14"
            variant="secondary"
            onClick={() => {
              selectedStaffRef.current = undefined;
              setOpenAddDialog(true);
            }}
          />
        </div>
      </div>
      <div className="saved-traveller-page" />
      <section className="saved-travellers-page app-container">
        {staffList && staffList.length === 0 && (
          <section className="p-3">
            <div className="not-found-icon">
              <MdOutlinePeopleOutline className="icon" />
            </div>
            <section className="text-center">
              <div className="head pb-2 fw-500">No staff added</div>
            </section>
          </section>
        )}
        {staffList && staffList.length > 0 && (
          <section className="body p-3">
            {staffList.map((staff) => (
              <Staff
                key={staff.AgentId}
                staff={staff}
                onEdit={handleOpenEdit}
                onChangePassword={handleOpenPasswordChangeModal}
              />
            ))}
          </section>
        )}
      </section>
      <Modal
        size="lg"
        backdrop="static"
        keyboard={false}
        show={openAddDialog}
        onHide={() => setOpenAddDialog(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedStaffRef.current &&
            selectedStaffRef.current.profileid !== '' &&
            selectedStaffRef.current.profileid !== undefined
              ? 'Update Staff'
              : 'Add Staff'}{' '}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddOrEditStaff
            selectedStaff={selectedStaffRef.current}
            onLoading={setIsLoading}
            onSave={handleSuccess}
          />
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        show={showChangePasswordPopup && staffForPasswordChangeRef.current}
        onHide={onClosePasswordModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="fw-500 mb-3">
            Change Password for {staffForPasswordChangeRef.current}
          </div>
          <div className="d-flex- flex-column">
            <div className="d-flex flex-column align-items-center gap-3">
              <AppTextInput
                type="password"
                name="newPassword"
                label="New Password"
                required
                placeholderText="Enter New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                errorText={validationError && 'Enter Password'}
              />
              <AppTextInput
                type="password"
                name="confirmNewPassword"
                label="Confirm Password"
                required
                placeholderText="Confirm Password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                errorText={validationError && 'Enter Password'}
              />
              <AppButton
                btnText="Change Password"
                onClick={handleChangePasswordForStaff}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default StaffPage;
